/**
 * Utility functions for cluster-related styling and operations
 */

/**
 * Returns the standard chip styling for cluster chips used across the application
 * @returns {Object} MUI sx prop object for cluster chip styling
 */
export const getClusterChipStyle = () => {
  return {
    height: '20px',
    fontSize: '0.7rem',
    backgroundColor: '#E2E8F0',
    color: '#2D3748',
    border: '1px solid #CBD5E0',
    fontWeight: 500
  };
}; 